import React, { useState } from 'react'
import styled from 'styled-components'
import { Left, Right } from './SidebarMenu';
import { FaAngleRight } from "react-icons/fa";
import SidebarCucuMenu from './SidebarCucuMenu';
import { useNavigate } from 'react-router-dom';

export const SubMenuItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 5px 12px;
    border-bottom: 1px solid black;
    cursor: pointer;
`
const CucuMenuContainer = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: white;
    transform: ${({ cucu }) => cucu ? 'translateX(0)' : 'translateX(200%)'};
    transition: transform 500ms ease-out;
`
export default function SidebarSubMenuItem({ subMenu, toggleSidebar }) {
  const [cucuMenu, setCucuMenu] = useState(false)
  const toggleCucuMenu = () => setCucuMenu(prev => !prev)
  const navigate = useNavigate()
  const subMenuOnClick = cucu => {
    if (cucu) {
      toggleCucuMenu()
    } else {
      navigate('/lists')
      toggleSidebar()
    }
}
  return (
      <>
        <SubMenuItem onClick={() => subMenuOnClick(subMenu.subSubNav)}>
            <Left>{subMenu.title}</Left>
            <Right>{subMenu.subSubNav && <FaAngleRight />}</Right>
        </SubMenuItem>
        <CucuMenuContainer cucu={cucuMenu}>
            <SidebarCucuMenu 
              judul={subMenu.title} 
              cucuMenuList={subMenu.subSubNav ? subMenu.subSubNav : null} 
              toggleCucuMenu={toggleCucuMenu} 
              toggleSidebar={toggleSidebar}
            />
        </CucuMenuContainer>
      </>
  )
}
